export default __webpack_public_path__ + "static/media/RC_Logo.cead4033.svg";